// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SAp8","footer":"styles_footer__2GMtn","passCodeTooltip":"styles_passCodeTooltip__1jYcy"};